import { useAuth0 } from '@auth0/auth0-react';
import { useQuery } from '@tanstack/react-query';
import { OrganizationClient } from './organization-client';

export const useUserAccountDetails = () => {
  const auth0 = useAuth0();
  const organizationClient = new OrganizationClient(auth0);

  const query = useQuery({
    queryKey: ['user-account-details'],
    queryFn: () =>
      organizationClient.getUserAccountDetails(auth0.user?.sub || ''),
    enabled: !!auth0.user,
    refetchOnMount: false,
  });

  return {
    ...query,
    createdAt: query.data?.createdAt,
    lastLogin: query.data?.lastLogin,
    isLoading: auth0.isLoading || query.isLoading,
  };
};
